import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import clubStore from '../../../storage/ClubStore'
import PageLayout from '../../PageLayout'
import appStore from '../../../storage/AppStore'
import './parent.css'
import Child from '../ParentMember/Child'

const Children = () => {
    const navigate = useNavigate();

    useEffect(() => {
        clubStore.parent.getChildren();
    }, []);

    return (
        <PageLayout
            header={
                <div className="flex justify-content-between align-items-center">
                    <h3 className="m-0">{appStore.tr.my_children}</h3>
                </div>
            }
        >
            <div className="grid children-grid">
                {clubStore.parent.children.map((child) => (
                    <Child child={child} key={child.id} url_base={'/parent/children'}/>
                ))}
            </div>
        </PageLayout>
    );
}

export default observer(Children)
